import axios from "axios";
import { api } from "~/router/apiConfig";

export function create(contractId, request) {
  return axios.post(
    api.path("contractCustomer.store", { contractId: contractId }),
    request
  );
}

export function update(contractId, customerId, request) {
  return axios.put(
    api.path("contractCustomer.update", {
      contractId: contractId,
      customerId: customerId
    }),
    request
  );
}

export function remove(contractId, customerId) {
  return axios.delete(
    api.path("contractCustomer.delete", {
      contractId: contractId,
      customerId: customerId
    })
  );
}

export function list(contractId, options = {}) {
  const url = api.path("contractCustomer.index", { contractId: contractId });
  const { includes = null } = options;

  if (includes && includes.length > 0) {
    const params = new URLSearchParams();
    includes.forEach((include) => {
      params.append("include[]", include);
    });
    return axios.get(`${url}?${params.toString()}`);
  }

  return axios.get(url);
}

export function show(contractId, customerId) {
  return axios.get(
    api.path("contractCustomer.show", {
      contractId: contractId,
      customerId: customerId
    })
  );
}

export function turnOn(contractId, customerId, request) {
  return axios.put(
    api.path("contractCustomer.turnOn", {
      contractId: contractId,
      customerId: customerId
    }),
    request
  );
}

export function turnOff(contractId, customerId, request) {
  return axios.put(
    api.path("contractCustomer.turnOff", {
      contractId: contractId,
      customerId: customerId
    }),
    request
  );
}
